import { Card, CardContent } from './ui/card';
import { Skeleton } from './ui/skeleton';
import { cn } from '../lib/utils';

export const PageLoadingState = ({
  summaryCards = 4,
  body = 'split',
  className,
}) => {
  const bodyContent =
    body === 'list' ? (
      <div className="space-y-4">
        {[1, 2, 3].map((item) => (
          <Skeleton key={item} className="h-36 rounded-[28px] border border-white/10 bg-white/[0.04]" />
        ))}
      </div>
    ) : body === 'single' ? (
      <Skeleton className="h-[420px] rounded-[28px] border border-white/10 bg-white/[0.04]" />
    ) : (
      <div className="grid gap-4 xl:grid-cols-[1.35fr_0.65fr]">
        <Skeleton className="h-[420px] rounded-[28px] border border-white/10 bg-white/[0.04]" />
        <Skeleton className="h-[420px] rounded-[28px] border border-white/10 bg-white/[0.04]" />
      </div>
    );

  return (
    <div className={cn('space-y-6', className)}>
      <Skeleton className="h-44 rounded-[32px] border border-white/10 bg-white/[0.04]" />
      <div className="grid gap-4 md:grid-cols-2 xl:grid-cols-4">
        {Array.from({ length: summaryCards }).map((_, index) => (
          <Skeleton
            key={index}
            className="h-28 rounded-2xl border border-white/10 bg-white/[0.04]"
          />
        ))}
      </div>
      {bodyContent}
    </div>
  );
};

export const ContextualState = ({
  icon: Icon,
  eyebrow,
  title,
  description,
  action,
  className,
  tone = 'light',
  ...props
}) => {
  const toneClasses =
    tone === 'dark'
      ? 'border-white/10 bg-white/[0.04] text-white'
      : 'border-border bg-muted/30 text-foreground';

  const descriptionTone = tone === 'dark' ? 'text-white/55' : 'text-muted-foreground';
  const iconTone = tone === 'dark' ? 'text-white/20' : 'text-muted-foreground/35';
  const eyebrowTone = tone === 'dark' ? 'text-white/45' : 'text-muted-foreground';

  return (
    <Card className={cn('rounded-[28px] border-dashed', toneClasses, className)} {...props}>
      <CardContent className="flex flex-col items-center justify-center px-6 py-14 text-center">
        {Icon && <Icon className={cn('mb-4 h-16 w-16', iconTone)} />}
        {eyebrow && (
          <p className={cn('text-xs uppercase tracking-[0.24em]', eyebrowTone)}>{eyebrow}</p>
        )}
        <h3 className="mt-2 text-lg font-semibold">{title}</h3>
        <p className={cn('mt-2 max-w-md text-sm', descriptionTone)}>{description}</p>
        {action ? <div className="mt-5">{action}</div> : null}
      </CardContent>
    </Card>
  );
};
